define('vspot-angular/services/calendar-service',[], function () {
    'use strict';

    return ['resources.Calendar', function (Calendar) {
        return {
            /*
             * Get the calendar subscription urls for an activity
             *
             * @returns  Resource object. See /resources.js documentation for details.
             */
            getUrls: function(activityId, timezone, showParticipantContactInfo, includeParticipantsInSpots, noDaylightSavingsTime) {
                return Calendar.getUrls({
                    id:                             activityId,
                    timezone:                       timezone,
                    show_participant_contact_info:  showParticipantContactInfo,
                    include_participants_in_spots:  includeParticipantsInSpots,
                    no_daylight_savings_time:       noDaylightSavingsTime
                });
            }
        };
    }];
});

